export const cutAddress = (display_name = '', count = 4) =>
	display_name.split(',').slice(0, count).join(',');
